import React from "react";

import { getUniqueContributorsAvatarURL } from "utility";
import { Shape } from "types";
import { Avatar, AvatarGroup } from "@mui/material";

type ContributorsProps = {
  shapes: Shape[];
};

export const Contributors: React.FC<ContributorsProps> = ({ shapes }) => {
  const avatarURls = getUniqueContributorsAvatarURL(shapes);

  if (avatarURls.length === 0) {
    return null;
  }

  return (
    <AvatarGroup
      max={3}
      sx={{
        justifyContent: "flex-end",
        "&>div:first-of-type": {
          width: "32px",
          height: "32px",
          fontSize: "1em",
        },
      }}
    >
      {avatarURls.map((avatar_url, idx) => (
        <Avatar
          key={idx}
          src={avatar_url ?? ""}
          sx={{ width: "32px", height: "32px" }}
        />
      ))}
    </AvatarGroup>
  );
};
